<script>

import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import config from "../../config";
import { productService } from "../../services";
import DropzonePopup from "../../components/widgets/dropzone-popup";
import draggable from "vuedraggable";
import { debounce,success_message,error_message } from "../../Helper/helper";


export default {
  components: { Layout, PageHeader, productService, DropzonePopup, draggable },
    data() {
        const { status,orderBy,sortBy} = this.$route.query;
        return {
            title: this.trans.get('__JSON__.Sub Products'),
            url: null,
            debounce: false,
            barcodeModal: false,
            items: [],
            checked: true,
            sortBy: sortBy || 'reorder',
            sortDesc: orderBy && orderBy != '' ? true : orderBy,
            loading: true,
            product: {},
            subProduct: {},
            limit: 1,
            status: status == undefined ? '1' :status,
            config: config,
            product_id: this.$route.params.product_id,
            productCount: "",
            barcode_image: "",
            image_id: "",
        };
    },
    mounted() {
        this.getSubProduct();
        this.getProductById();
    },
    methods: {
        sortingChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getSubProduct();
        },
        getSubProduct(page) {
            this.loading = true;
            productService
            .getSubProduct({ 
                status: this.status,
                sortBy: this.sortBy,
                orderBy: this.sortDesc ? "desc" : "asc",
                page: page && page > 0 ? page : 1,
                product_id : this.product_id
            })
            .then((response) => {
                this.loading = false;
                this.items = response.data.result.data;
                this.productCount = response.data.result.data.length;
            });
        },
        getProductById(){
            productService
            .getProductById({id: this.$route.params.product_id, type:'get'})
            .then((response) => {
                this.product = response.data.result;
            });
        },
         updateProductOrder: function() {
            var items = this.items.map(function(item, index) {
                return { item: item, order: index }
            });
            // if(this.debounce) return
            
            var ids = items.map(item => item.item.id);
            
            this.debounce = setTimeout(function(items) {
                this.debounce = false;
                productService.updateSubProductOrder({ ids : ids})
                .then(response => {
                if (response.data.code === 200) {
                    this.getSubProduct();
                }
                });
            }.bind(this, items), 10)
        },
    },
};

</script>
<template>
    <Layout>
        <div>
            <div class="row">
                <div class="col-12">
                    <div class="page-title-box d-flex align-items-center justify-content-between icon-main-page" >
                        <div class="page-title-left">
                            <div class="avatar-xs mr-3 avatar-main-icon">
                                <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                                    <i class="bx bx-user-circle"></i>
                                </span>
                            </div>
                            <div class="report-tag">
                                <h4 class="mb-0 font-size-18">{{ product.item_name }}</h4>
                                <p><router-link :to="{ name: 'product-list'}">{{ trans.get('__JSON__.Products') }}</router-link> > {{ product.item_name }} > {{ trans.trans('__JSON__.Sub Products') }}({{productCount}})</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row list-table-main">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 table-main-list product-table table-responsive custom-tbl">
                                    <div class="card task-box custom-tblheader">
                                        <div class="card-body menu-items">
                                            <div class="media">
                                            <div class="tbl-pro-heading mr-4 font-weight-bolder"> # </div>
                                            <div class="tbl-pro-heading mr-4 font-weight-bolder"> {{ trans.get('__JSON__.Barcode') }} </div>
                                            <div class="tbl-pro-heading mr-4 font-weight-bolder"> {{ trans.get('__JSON__.Product Number') }} </div>
                                            <div class="tbl-pro-heading mr-4 font-weight-bolder"> {{ trans.get('__JSON__.Status') }} </div>
                                            </div>
                                        </div>
                                    </div>
                                    <draggable class="list-group" group="item" :list="items" v-model="items" @end="updateProductOrder">
                                        <div v-for="item in items" :key="item.id" class="card task-box">
                                            <div class="card-body menu-items drag-item">
                                                <div class="media">
                                                    <div class="avatar-md tbl-pro-heading mr-4">
                                                        <span class="text-danger font-size-16" v-bind:id="item.id" >
                                                            <div v-if="item.product_image[0]">
                                                                <img alt title="image"
                                                                    class="vendor-img avatar-xs"
                                                                    :src="item.image_path+item.id+'/original/'+item.product_image[0].image"
                                                                />   
                                                            </div>
                                                            <div v-else>
                                                                <img class="avatar-md rounded-circle-banner" :src="config.basepath+'no-img.png'"/>
                                                            </div>
                                                        </span>
                                                    </div>

                                                    <div class="tbl-pro-heading mr-4">
                                                        <h5 class="font-size-14">{{item.barcode_number}}</h5>
                                                    </div>
                                                    
                                                    <div class="tbl-pro-heading mr-4">
                                                        <span>{{item.product_number}}</span>
                                                    </div>

                                                    <div class="tbl-pro-heading mr-4">
                                                        <span>{{item.status}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </draggable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style>
/* .product-table .table thead th:nth-child(1),.product-table .table thead th:nth-child(5){
    pointer-events: none;
} */
.product-table .custom-tblheader .card-body{
    height: auto;
    background-color: #b3b0b033 !important;
    border-bottom: 0 solid #b3b0b033 !important;
}
.custom-tbl .media{
    align-items: center;
}
.tbl-pro-heading:first-child{
    width: 10rem;
}
.tbl-pro-heading:nth-child(2){
    width: 12rem;
}
.tbl-pro-heading:nth-child(3){
    width: 12rem;
}
.drag-item.menu-items{
  height: auto;
}
</style>